import { observer } from 'mobx-react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';

import zrno01 from 'img/01.png';
import zrno02 from 'img/02.png';
// import zrno03 from 'img/03.png';
import zrno04 from 'img/04.png';
// import zrno05 from 'img/05.png';
import zrno06 from 'img/06.png';
import zrno07 from 'img/07.png';
import zrno08 from 'img/08.png';
import zrno09 from 'img/09.png';
import zrno10 from 'img/10.png';
import zrno11 from 'img/11.png';
import zrno12 from 'img/12.png';
import zrno13 from 'img/13.png';
import zrno14 from 'img/14.png';
import zrno15 from 'img/15.png';
import zrno16 from 'img/16.png';
import zrno17 from 'img/17.png';
import zrno18 from 'img/18.png';
import zrno19 from 'img/19.png';
import zrno20 from 'img/20.png';
import zrno21 from 'img/21.png';
import zrno22 from 'img/22.png';
import zrno23 from 'img/23.png';
import zrno24 from 'img/24.png';
import zrno25 from 'img/25.png';
import zrno26 from 'img/26.png';
import zrno27 from 'img/27.png';
import zrno28 from 'img/28.png';
import zrno29 from 'img/29.png';
import zrno30 from 'img/30.png';
import zrno31 from 'img/31.png';
import zrno32 from 'img/32.png';
import zrno33 from 'img/33.png';
import zrno34 from 'img/34.png';
import zrno35 from 'img/35.png';
import zrno36 from 'img/36.png';
import zrno37 from 'img/37.png';
import zrno38 from 'img/38.png';
import zrno39 from 'img/39.png';
import zrno40 from 'img/40.png';
import zrno41 from 'img/41.png';
import zrno42 from 'img/42.png';
import zrno43 from 'img/43.png';
import zrno44 from 'img/44.png';
import zrno45 from 'img/45.png';
import zrno46 from 'img/46.png';
import zrno47 from 'img/47.png';
import zrno48 from 'img/48.png';
import zrno49 from 'img/49.png';
import zrno50 from 'img/50.png';
import zrno51 from 'img/51.png';
import zrno52 from 'img/52.png';
import zrno53 from 'img/53.png';
import zrno54 from 'img/54.png';
import zrno55 from 'img/55.png';
import zrno56 from 'img/56.png';
import zrno57 from 'img/57.png';
import zrno58 from 'img/58.png';
import zrno59 from 'img/59.png';
import zrno60 from 'img/60.png';
import zrno61 from 'img/61.png';

import { storeKrunica } from '../store/KrunicaStore';
import OceNas from './OceNas';
import SlikaBozanskoMilosrde from './slike/SlikaBozanskoMilosrde';
import ZdravoMarijaPocetak from './ZdravoMarijaPocetak';
import ZdravoMarijaKraj from './ZdravoMarijaKraj';
import ZrnoText from './ZrnoText';
import Amen from './Amen';

const useStyles = makeStyles((theme) => ({
  opisZrnaKrunica: {
    display: 'flex',
    fontSize: '2rem',
    marginTop: '1rem',
    justifyContent: 'space-between',
    backgroundSize: '1.5rem',
    marginBottom: '2rem',
    textAlign: 'center',
    borderRadius: '0.2rem',
  },
  slikaKrunice: {
    position: 'relative',
    left: '0',
    top: '0',
    height: '80vh',
    width: '100%',
  },
  sliBaza: {
    position: 'absolute',
    display: 'block',
    top: '-15px',
    left: '0',
    opacity: '0.05',
  },
  slomiLiniju: {
    whiteSpace: 'pre-line',
  },
  opisZrnaDesetice: {
    fontSize: '1.2rem',
    fontStyle: 'italic',
    marginTop: '0.2rem',
  },
  opisIsus: {
    fontSize: '1.6rem',
    // fontStyle: 'italic',
    marginTop: '1rem',
  },
  opisLitanije: {
    fontSize: '1.4rem',
    textAlign: 'left',
    listStyle: 'none',
    // fontStyle: 'italic',
    // marginTop: '1rem',
  },
  nivo: {
    zIndex: '5',
  },
  [theme.breakpoints.up('sm')]: {
    backgroundColor: 'blue',
    color: '#555',
    border: '1px solid #ece7e7',
    sliBaza: {
      position: 'absolute',
      display: 'block',
      top: '-10px',
      left: '-50%',
      width: '300px',
      opacity: '0.05',
    },
    slikaKrunice: {
      position: 'relative',
      left: '31%',
      top: '0',
      height: '100vh',
      width: '40%',
    },
    opisZrnaKrunica: {
      padding: '3rem',
    },
  },
}));

function KrunicaBozanskogMilosrda() {
  const classes = useStyles();
  const { zrno, trenutnaKrunica, aktivnaZemlja } = storeKrunica;
  const {
    uImeOcaSina,
    krunice,
    apostolskoVjerovanje,
    apostolskoVjerovanjeText,
    litanijeBozanskogMilosrdja,
  } = aktivnaZemlja;
  var sirina = window.innerWidth;
  var visina = window.innerHeight * 0.8;
  const zrnoKorigirano = zrno + 2;
  // console.log('zrno u Boženskog milosrda=', zrno, zrnoKorigirano);
  // console.log('zrno u Boženskog milosrda=', litanijeBozanskogMilosrdja);
  return (
    <div className={classes.slikaKrunice}>
      <Container>
        <ZrnoText />
        {zrnoKorigirano === 1 && <SlikaBozanskoMilosrde />}
        {zrnoKorigirano === 2 && (
          <div className={classes.opisIsus}>
            {uImeOcaSina}
            <Amen />
          </div>
        )}
        {zrnoKorigirano === 2 && <OceNas />}
        {zrnoKorigirano === 3 && <ZdravoMarijaPocetak />}
        {zrnoKorigirano === 3 && (
          <div className={classes.opisIsus}>
            {krunice.find((k) => k.value === trenutnaKrunica)?.vjera}
          </div>
        )}
        {zrnoKorigirano === 3 && <ZdravoMarijaKraj />}
        {zrnoKorigirano === 3 && <Amen />}
        {zrnoKorigirano === 4 && (
          <div className={classes.opisIsus}>{apostolskoVjerovanje}</div>
        )}
        {zrnoKorigirano === 4 && (
          <div className={classes.opisIsus}>{apostolskoVjerovanjeText}</div>
        )}
        {(zrnoKorigirano === 5 ||
          zrnoKorigirano === 16 ||
          zrnoKorigirano === 27 ||
          zrnoKorigirano === 38 ||
          zrnoKorigirano === 49) && (
          <div className={classes.opisIsus}>
            {krunice.find((k) => k.value === trenutnaKrunica)?.vjecniOce}
          </div>
        )}
        {((zrnoKorigirano > 5 && zrnoKorigirano < 16) ||
          (zrnoKorigirano > 16 && zrnoKorigirano < 27) ||
          (zrnoKorigirano > 27 && zrnoKorigirano < 38) ||
          (zrnoKorigirano > 38 && zrnoKorigirano < 49) ||
          (zrnoKorigirano > 49 && zrnoKorigirano < 60)) && (
          <div className={classes.opisIsus}>
            {krunice.find((k) => k.value === trenutnaKrunica)?.pregorkaMuka}
          </div>
        )}
        {zrnoKorigirano === 60 && (
          <div className={classes.opisIsus}>
            {krunice.find((k) => k.value === trenutnaKrunica)?.krajKrunice}
          </div>
        )}
        {zrnoKorigirano === 60 && (
          <div className={classes.opisIsus}>
            {krunice.find((k) => k.value === trenutnaKrunica)?.krajKrunice}
          </div>
        )}
        {zrnoKorigirano === 60 && (
          <div className={classes.opisIsus}>
            {krunice.find((k) => k.value === trenutnaKrunica)?.krajKrunice}
          </div>
        )}
        {zrnoKorigirano === 61 && (
          <div className={classes.opisIsus}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.zakljucnaMolitvaKrvi
            }
          </div>
        )}
        {zrnoKorigirano === 61 && (
          <div className={classes.opisIsus}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.zakljucnaMolitvaMarijo
            }
          </div>
        )}
        {zrnoKorigirano === 61 && (
          <div className={classes.opisIsus}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.zakljucnaMolitvaIsuse
            }
          </div>
        )}
        {zrnoKorigirano === 61 && (
          <div className={classes.opisIsus}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.zakljucnaMolitvaIsuse
            }
          </div>
        )}
        {zrnoKorigirano === 61 && (
          <div className={classes.opisIsus}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.zakljucnaMolitvaIsuse
            }
          </div>
        )}
        {zrnoKorigirano === 61 && (
          <div className={classes.opisIsus}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.zakljucnaMolitvaGospodine
            }
          </div>
        )}
        {zrnoKorigirano === 62 && (
          <div>{krunice.find((k) => k.value === trenutnaKrunica)?.zaziv}</div>
        )}
        {zrnoKorigirano === 62 && (
          <div>
            <ul className={classes.opisLitanije}>
              {litanijeBozanskogMilosrdja.map((red, index) => {
                return (
                  <li key={index}>
                    {red.naslov && <strong>{red.naslov}</strong>}
                    {red.naslov ? ' ' : ''}
                    {red.tekst}
                    {red.odgovor && (
                      <span>
                        {' '}
                        — <b>{red.odgovor}</b>
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {zrnoKorigirano === 62 && (
          <div className={classes.opisIsus}>
            {uImeOcaSina}
            <Amen />
          </div>
        )}
      </Container>
      <Container>
        <div className={classes.sliBaza}>
          {zrnoKorigirano === 2 && (
            <img src={zrno01} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 3 && (
            <img src={zrno02} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 4 && (
            <img src={zrno04} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 5 && (
            <img src={zrno06} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 6 && (
            <img src={zrno07} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 7 && (
            <img src={zrno08} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 8 && (
            <img src={zrno09} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 9 && (
            <img src={zrno10} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 10 && (
            <img src={zrno11} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 11 && (
            <img src={zrno12} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 12 && (
            <img src={zrno13} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 13 && (
            <img src={zrno14} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 14 && (
            <img src={zrno15} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 15 && (
            <img src={zrno16} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 16 && (
            <img src={zrno17} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 17 && (
            <img src={zrno18} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 18 && (
            <img src={zrno19} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 19 && (
            <img src={zrno20} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 20 && (
            <img src={zrno21} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 21 && (
            <img src={zrno22} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 22 && (
            <img src={zrno23} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 23 && (
            <img src={zrno24} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 24 && (
            <img src={zrno25} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 25 && (
            <img src={zrno26} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 26 && (
            <img src={zrno27} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 27 && (
            <img src={zrno28} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 28 && (
            <img src={zrno29} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 29 && (
            <img src={zrno30} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 30 && (
            <img src={zrno31} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 31 && (
            <img src={zrno32} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 32 && (
            <img src={zrno33} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 33 && (
            <img src={zrno34} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 34 && (
            <img src={zrno35} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 35 && (
            <img src={zrno36} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 36 && (
            <img src={zrno37} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 37 && (
            <img src={zrno38} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 38 && (
            <img src={zrno39} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 39 && (
            <img src={zrno40} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 40 && (
            <img src={zrno41} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 41 && (
            <img src={zrno42} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 42 && (
            <img src={zrno43} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 43 && (
            <img src={zrno44} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 44 && (
            <img src={zrno45} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 45 && (
            <img src={zrno46} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 46 && (
            <img src={zrno47} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 47 && (
            <img src={zrno48} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 48 && (
            <img src={zrno49} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 49 && (
            <img src={zrno50} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 50 && (
            <img src={zrno51} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 51 && (
            <img src={zrno52} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 52 && (
            <img src={zrno53} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 53 && (
            <img src={zrno54} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 54 && (
            <img src={zrno55} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 55 && (
            <img src={zrno56} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 56 && (
            <img src={zrno57} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 57 && (
            <img src={zrno58} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 58 && (
            <img src={zrno59} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 59 && (
            <img src={zrno60} height={visina} width={sirina} alt="Krunica" />
          )}
          {zrnoKorigirano === 60 && (
            <img src={zrno61} height={visina} width={sirina} alt="Krunica" />
          )}
        </div>
      </Container>
    </div>
  );
}

export default observer(KrunicaBozanskogMilosrda);
